module.exports = __webpack_public_path__ + "3444e1b684939c251a69b8c7e57390e4.jpg";